import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Card,
  Switch,
  Select,
  Collapse,
  message,
} from "antd";
import capitalizeWords from "../../../common/formatter";
import axios from "axios";
import SummaryApi from "../../../common/index";
import "../../../Styles/AdminStylings/EditSellerDetails.css";

const { Title, Text } = Typography;
const { Panel } = Collapse;
const { Option } = Select;

const EditSellerDetails = ({ seller, refreshSeller }) => {
  const [loading, setLoading] = useState(false);

  if (!seller) return <div>Select a seller to edit</div>;

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
       const payload = {
      ...values,
      name: capitalizeWords(values.name),
      store_name: capitalizeWords(values.store_name),
    };

      const res = await axios.put(SummaryApi.editSeller(seller.id).url, values, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        message.success("Seller details updated successfully");
        refreshSeller();
      } else {
        message.error("Failed to update seller");
      }
    } catch (err) {
      console.error(err);
      message.error("Error updating seller");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="edit-seller-wrapper">
      <Card className="edit-seller-card" bordered={false}>
        <Title level={2} className="edit-seller-title">
          Edit Seller:{capitalizeWords(seller.store_name)}
        </Title>
        <Text type="secondary" className="edit-seller-subtitle">
          Update seller account, address, and license information
        </Text>

        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            name: seller.name || "",
            store_name: seller.store_name || "",
            email: seller.email || "",
            phone: seller.phone || "",
            gst_no: seller.gst_no || "",
            registration_no: seller.registration_no || "",
            store_street: seller.store_street || "",
            store_area: seller.store_area || "",
            store_city: seller.store_city || "",
            store_pincode: seller.store_pincode || "",
            district: seller.district || "",
            state: seller.state || "",
            registration_completed: seller.registration_completed || false,
            status: seller.status || "pending",
          }}
          disabled={loading}
        >
          {/* 1️⃣ ACCOUNT DETAILS */}
          <Title level={4} style={{ marginTop: 20 }}>
            🧾 Account Details
          </Title>
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label="Seller Name"
                rules={[{ required: true, message: "Enter seller name" }]}
              >
                <Input placeholder="Enter seller name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="store_name"
                label="Store Name"
                rules={[{ required: true, message: "Enter store name" }]}
              >
                <Input placeholder="Enter store name" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email", message: "Enter valid email" }]}
              >
                <Input placeholder="Enter email address" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="phone"
                label="Phone Number"

                rules={[{ required: true, pattern: /^[0-9]{10}$/, message: "Enter valid 10-digit phone" }]}
              >
                <Input placeholder="Enter phone number" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>

          {/* 2️⃣ STORE & ADDRESS DETAILS */}
          <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
            <Panel header="📍 Store & Address Details" key="1">
              <Row gutter={24}>
                <Col xs={24}>
                  <Form.Item name="store_street" label="Street">
                    <Input placeholder="Street / landmark" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item name="store_pincode" label="Pincode">
                    <Input placeholder="6-digit pincode" maxLength={6} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item name="store_city" label="City">
                    <Input placeholder="City" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24} md={12}>
                  <Form.Item name="store_area" label="Area / Locality">
                    <Input placeholder="Area / Locality" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item name="district" label="District">
                    <Input placeholder="District" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24}>
                  <Form.Item name="state" label="State">
                    <Input placeholder="State" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>

          {/* 3️⃣ LICENSE & STATUS */}
          <Title level={4} style={{ marginTop: 25 }}>
            📄 License & Status
          </Title>
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item name="gst_no" label="GST Number">
                <Input placeholder="Enter GST number" />
              </Form.Item>
              <Form.Item name="registration_no" label="License / Registration No.">
                <Input placeholder="Enter registration number" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item name="registration_completed" label="Registration Completed" valuePropName="checked">
                <Switch />
              </Form.Item>

              <Form.Item
                name="status"
                label="Seller Status"
                rules={[{ required: true, message: "Select seller status" }]}
              >
                <Select placeholder="Select status">
                  <Option value="pending">Pending</Option>
                  <Option value="active">Active</Option>
                  <Option value="rejected">Rejected</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* SUBMIT BUTTON */}
          <Form.Item style={{ marginTop: 24 }}>
            <Button type="primary" htmlType="submit" block loading={loading} style={{ fontWeight: "bold" }}>
              Update Seller
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditSellerDetails;
